/**
 * @description 最底层的layout，所有的layout都需要继承这个, 这个基类不要在动他。
 * @author duanjun
 */

import { IBaseData } from './interface';

abstract class BasicLayout<T extends IBaseData, K> {
    protected SYSTEM: string = '';
    protected isSystemTW: boolean = false;
    protected isSystemEN: boolean = false;
    protected isSystemEM: boolean = false;
    protected useSentry: boolean = false;
    private bodyClassName: string = '';

    constructor(public data: T, public options: K) {
        this.SYSTEM = data.SYSTEM;
        this.isSystemTW = data.SYSTEM === '"TW"' || data.SYSTEM === 'TW';
        this.isSystemEN = data.SYSTEM === '"EN"' || data.SYSTEM === 'EN';
        this.isSystemEM = data.SYSTEM === '"EM"' || data.SYSTEM === 'EM';

        this.useSentry = this.isSystemTW || this.isSystemEN;
    }

    public setBodyClassName(cls: string) {
        this.bodyClassName = cls;
    }

    public renderLangScriptInTemplate() {
        return `
             <script>
                var pageData={{pageData|default({}, true)|jsonsafe}}
                window.langMap = {{langMap|default({}, true)|jsonsafe}}
             </script>
             {{i18nScripts|safe}}
         `;
    }

    public renderLangScriptInJs() {
        return `
             ${this.renderLangScriptInTemplate()}
         `;
    }

    public renderHeader() {
        return this.renderLangScriptInJs();
    }

    public renderContent() {
        return '';
    }

    public renderFooter() {
        return '';
    }

    public render() {
        return `<!DOCTYPE html>
             <html class="{{tplClassNames.htmlFontSize}}">
             <head>
                 ${this.renderHeader()}
             </head>
             <body class="${this.bodyClassName}">
                 ${this.renderContent()}
                 ${this.renderFooter()}
             </body>
             </html>`;
    }
}

export default BasicLayout;
